<template>
  <div>
    <div class="jdbn">
      <img
        style="width: 100%; height: 100%"
        src="../../assets/base/4jd/banner4.png"
      />
    </div>
    <div class="amap-wrapper">
      <el-amap class="amap-box" :vid="'amap-vue'" :center="center" :zoom="zoom">
        <!--marker-->
        <el-amap-marker
          v-for="(marker, index) in markers"
          :key="'marker' + index"
          :position="marker"
          :label="label"
        >
        </el-amap-marker>
      </el-amap>
    </div>
    <main>
      <div class="main-banner">
        <img src="../../assets/base/banner1-3X-1301_118.png" />
      </div>
      <div class="main-baseintur">
        <img src="../../assets/base/4jd/基地介绍-4.png" />
        <!-- <p>
                四基地重庆攀润钢材加工有限公司，隶属于重庆二轻供销总公司金材分公司，成立于2020年11月17日，位于九龙坡区跳蹬镇，占地9亩，北临重庆西站，紧靠跳蹬轻轨站。依附铁路中铁货运站及国储436处，周边拥有重庆最大的钢材市场绿云市场和众多工业园区和主机厂，地理位置优越。

            </p> -->
      </div>
      <div class="main-service">
        <img src="../../assets/base/4jd/星级服务-3X-1334_527.jpg" alt="" />
      </div>

      <div class="main-cut">
        <img src="../../assets/base/4jd/1850纵切机组-3X-1314_865.jpg" />
		<img src="../../assets/base/4jd/1350横切机组-3X-1314_828-.jpg" />
      </div>
      <div class="Shear_unit" v-if="0">
        <img  style="width:80%;height:50%;" src="../../assets/base/4jd/1850纵切机组-3X-1314_865.jpg" alt="" />
      </div>
      <div class="main-bottom">
        <img src="../../assets/base/bottom-3X-1580_435.png" alt="" />
      </div>
    </main>
  </div>
</template>
  <script>
export default {
  data() {
    return {
      center: [106.424575, 29.430604],
      zoom: 13,
      markers: [],
      radius: 10,
      label: {
        content: "四基地·重庆攀润钢材加工有限公司——(重庆市九龙坡区跳蹬镇)",
        offset: [10, 12],
      },
    };
  },
  mounted() {
    this.markers.push([106.424575, 29.430604]);
  },
};
</script><style lang="less" scoped>
.amap-wrapper {
  width: 100%;
  height: 300px;
}
.jdbn {
  margin-bottom: 4px;
  width: 100%;
}
main {
  .main-banner {
    padding: 40px 27px 70px 0;
    width: 100%;
    background: rgb(20, 157, 214);
    box-sizing: border-box;

    img {
      width: 90%;
      margin-left: 5%;
    }
  }

  .main-baseintur {
    width: 100%;
    position: relative;
	background-color: #149DD6;
    img {
      width: 100%;
    }

    p {
      width: 45%;
      position: absolute;
      top: 33%;
      left: 35%;
      font-size: 24px;
      line-height: 40px;
      color: #ffffff;
    }
  }
  .main-service {
    width: 100%;
    position: relative;
	background-color: #149DD6;
    img {
      width: 100%;
    }
    .service-content {
      width: 80%;
      position: absolute;
      top: 25%;
      left: 20%;
      transform: translateX(-20%);
    }
  }
  .main-cut {
    width: 100%;
    margin-top: 40px;
    position: relative;
    img {
      width: 100%;
    }
    .cut-content {
      width: 100%;
      position: absolute;
      top: 25%;
      left: 0;
      .swiper-wrapper {
        margin-left: 10%;
      }

      .swiper-slide {
        img {
          width: 80%;
        }
      }
      .base3-wrapper {
        margin-left: 25%;
      }
      .base3-slide {
        img {
          width: 50%;
        }
      }
      .swiper-button-prev {
        width: 60px;
        height: 60px;
      }
      .swiper-button-next {
        width: 60px;
        height: 60px;
      }
    }
  }
  .main-bottom {
    width: 100%;
    background-image: linear-gradient(180deg, #19a7df 0%, #0881ba 100%);
    img {
      width: 100%;
    }
  }
}
.mybox{
    width:100%;
	height:100%;
    padding-top:80px;
    background-size:100% 100%;
    background-repeat: no-repeat;

}
.h530{
	overflow-y: auto;
	min-height: 1000px;
	background-color: #149DD6;
}
</style>
